import { toTelHref } from 'utils/phone-number';

export const DOLLY_SUPPORT_NUMBER = ` 1-844-571-1131`;

export const MINIMOVES_LOGO_URL =
  'https://res.cloudinary.com/updater-staging/image/upload/q_auto/f_auto/v1776280007/partner-logos/minimoves.png';

export const MINIMOVES_PHONE_NUMBER = '18337481230';
export const MINIMOVES_PHONE_HREF = toTelHref(MINIMOVES_PHONE_NUMBER);

export const MOVE_FLOW_DOMAINS = {
  MOVING_TAB: 'moving_tab',
  /**
   * MYS = "Move Your Stuff" & Dolly.
   */
  MYS: 'mys',
  /**
   * MS = "Move Services".
   */
  MS_BOXES: 'ms_boxes',
};

/**
 * Which partner/path completed the MOVE_YOUR_STUFF item, stored in the
 * item's `metadata.mys_completion_source`. Lets completed-task UI (e.g. the
 * Essentials tab card) route back to the right partner instead of assuming
 * MiniMoves, since all four paths mark the same item COMPLETED.
 */
export const MYS_COMPLETION_SOURCES = {
  MINIMOVES: 'minimoves',
  TASKRABBIT: 'taskrabbit',
  PENSKE: 'penske',
  FULL_SERVICE_PARTNERS: 'full_service_partners',
} as const;

export type MysCompletionSource =
  (typeof MYS_COMPLETION_SOURCES)[keyof typeof MYS_COMPLETION_SOURCES];
